import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import SingleValueList from "~/componentes/SingleValueList";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";
import api from "~/services/api";

import { Container } from "./styles";

function ProdutosList({ defaultData, setter }) {
  const [produtos, setProdutos] = useState([]);
  const [produto, setProduto] = useState();
  const [dfSelected, setDfSelected] = useState([]);
  const [dfAvailable, setDfAvailable] = useState([]);
  const [upgradeSetter, setUpgradeSetter] = useState(false);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/gerencia/produtos", { params: { ativo: 1 } }).then((r) => setProdutos(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      setDfSelected((prev) => {
        const newData =
          defaultData.filter((e) => !prev?.find((p) => p?.id === e?.id)) || [];

        return [...prev, ...newData];
      });

      if (edit) {
        setter((prev) => {
          const newData =
            defaultData.filter((e) => !prev?.find((p) => p?.id === e?.id)) || [];

          return [...prev, ...newData];
        });
      }
    }
  }, [defaultData, setter, edit, editShow]);

  useEffect(() => {
    const newData = produtos.filter((e) => !dfSelected?.find((p) => p?.id === e?.id)) || [];

    setDfAvailable(newData);
  }, [dfSelected, produtos]);

  useEffect(() => {
    if (dfAvailable.length > 0) {
      setProduto(dfAvailable[0]);
    }

  }, [dfAvailable]);

  useEffect(() => {
    if (upgradeSetter === true) {
      setUpgradeSetter(false);
      setter(dfSelected);
    }
  }, [dfSelected, upgradeSetter, setter]);

  function handleAddProduto() {
    if (produto?.id) {
      const checkProduto = dfSelected?.find((e) => e?.id === produto?.id);

      if (!checkProduto) {
        setDfSelected((prev) => [...prev, produto]);
        setUpgradeSetter(true);
      }
    }
  }

  function handleRemoveProduto(data) {
    setDfSelected((prev) => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex((e) => e?.id === data?.id);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
    setUpgradeSetter(true);
  }

  return (
    <Container>
      <Label title="Produtos *" />
      {!(editShow && edit) && (
        <div className="Analista_div_addProdutos">
          <Select
            list={{ list: dfAvailable, value: "id", label: "titulo" }}
            setList={setProduto}
            defaultValue={produto?.id}
          />
          <ColoredButton small blueLayout type="button" onClick={handleAddProduto}>
            Adicionar
          </ColoredButton>
        </div>
      )}
      <SingleValueList
        data={dfSelected}
        dataKey="titulo"
        {...{ ...(editShow && edit ? {} : { materialIcon: "close" }) }}
        iconClick={handleRemoveProduto}
      />
    </Container>
  );
}

export default ProdutosList;
